import { createStructuredSelector } from "reselect";
import {
    AMBULANCE_DOCUMENT_USER,
    AMBULANCE_DOCUMENT_USER_SUCCESS,
    AMBULANCE_DOCUMENT_USER_ERROR,
    AMBULANCE_DOCUMENT_CODE_IGSS,
    AMBULANCE_DOCUMENT_CODE_IGSS_SUCCESS,
    AMBULANCE_DOCUMENT_CODE_IGSS_ERROR,
    AMBULANCE_DOCUMENT_PLATES,
    AMBULANCE_DOCUMENT_PLATES_SUCCESS,
    AMBULANCE_DOCUMENT_PLATES_ERROR,
    AMBULANCE_DOCUMENT_CHASIS,
    AMBULANCE_DOCUMENT_CHASIS_SUCCESS,
    AMBULANCE_DOCUMENT_CHASIS_ERROR,
    AMBULANCE_DOCUMENT_STATUS_REVIEW,
    AMBULANCE_DOCUMENT_STATUS_REVIEW_SUCCESS,
    AMBULANCE_DOCUMENT_STATUS_REVIEW_ERROR,
    AMBULANCE_DOCUMENT_USER_ASSIGNED,
    AMBULANCE_DOCUMENT_USER_ASSIGNED_SUCCESS,
    AMBULANCE_DOCUMENT_USER_ASSIGNED_ERROR,
    AMBULANCE_DOCUMENT_USERS_FOR_ASSIGN,
    AMBULANCE_DOCUMENT_USERS_FOR_ASSIGN_SUCCESS,
    AMBULANCE_DOCUMENT_USERS_FOR_ASSIGN_ERROR,
    AMBULANCE_DOCUMENT_LIST,
    AMBULANCE_DOCUMENT_LIST_SUCCESS,
    AMBULANCE_DOCUMENT_LIST_ERROR,
    AMBULANCE_DOCUMENT_LIST_SEARCH_CHANGE,
    AMBULANCE_DOCUMENT_LIST_PAGE_SET,
    AMBULANCE_DOCUMENT_ASSIGN_MODAL_SET,
    AMBULANCE_DOCUMENT_ASSIGN_CHANGE_SET,
    AMBULANCE_DOCUMENT_ASSIGN,
    AMBULANCE_DOCUMENT_ASSIGN_SUCCESS,
    AMBULANCE_DOCUMENT_ASSIGN_ERROR,
    AMBULANCE_DOCUMENT_VALIDATE_MODAL_SET,
    AMBULANCE_DOCUMENT_VALIDATE_CHANGE_SET,
    AMBULANCE_DOCUMENT_VALIDATE,
    AMBULANCE_DOCUMENT_VALIDATE_SUCCESS,
    AMBULANCE_DOCUMENT_VALIDATE_ERROR,
    AMBULANCE_DOCUMENT_SEE_MODAL_SET,
    AMBULANCE_DOCUMENT_SEE_CHANGE_SET,
    AMBULANCE_DOCUMENT_SEE_DOCUMENT,
    AMBULANCE_DOCUMENT_SEE_DOCUMENT_SUCCESS,
    AMBULANCE_DOCUMENT_SEE_DOCUMENT_ERROR,
} from "../../actions";

export const NAME = 'ambulanceDocument';

export const AmbulanceDocumentSelector = createStructuredSelector({
    ambulanceDocument: (state) => state.ambulanceDocument,
});

export const AmbulanceDocumentUser = (data) => ({ type: AMBULANCE_DOCUMENT_USER, payload: data });
export const AmbulanceDocumentUserSuccess = (data) => ({ type: AMBULANCE_DOCUMENT_USER_SUCCESS, payload: data });
export const AmbulanceDocumentUserError = (error) => ({ type: AMBULANCE_DOCUMENT_USER_ERROR, payload: error });

export const AmbulanceDocumentCodeIgss = (data) => ({ type: AMBULANCE_DOCUMENT_CODE_IGSS, payload: data });
export const AmbulanceDocumentCodeIgssSuccess = (data) => ({ type: AMBULANCE_DOCUMENT_CODE_IGSS_SUCCESS, payload: data });
export const AmbulanceDocumentCodeIgssError = (error) => ({ type: AMBULANCE_DOCUMENT_CODE_IGSS_ERROR, payload: error });

export const AmbulanceDocumentPlates = (data) => ({ type: AMBULANCE_DOCUMENT_PLATES, payload: data });
export const AmbulanceDocumentPlatesSuccess = (data) => ({ type: AMBULANCE_DOCUMENT_PLATES_SUCCESS, payload: data });
export const AmbulanceDocumentPlatesError = (error) => ({ type: AMBULANCE_DOCUMENT_PLATES_ERROR, payload: error });

export const AmbulanceDocumentChasis = (data) => ({ type: AMBULANCE_DOCUMENT_CHASIS, payload: data });
export const AmbulanceDocumentChasisSuccess = (data) => ({ type: AMBULANCE_DOCUMENT_CHASIS_SUCCESS, payload: data });
export const AmbulanceDocumentChasisError = (error) => ({ type: AMBULANCE_DOCUMENT_CHASIS_ERROR, payload: error });

export const AmbulanceDocumentStatusReview = (data) => ({ type: AMBULANCE_DOCUMENT_STATUS_REVIEW, payload: data });
export const AmbulanceDocumentStatusReviewSuccess = (data) => ({ type: AMBULANCE_DOCUMENT_STATUS_REVIEW_SUCCESS, payload: data });
export const AmbulanceDocumentStatusReviewError = (error) => ({ type: AMBULANCE_DOCUMENT_STATUS_REVIEW_ERROR, payload: error });

export const AmbulanceDocumentUserAssigned = (data) => ({ type: AMBULANCE_DOCUMENT_USER_ASSIGNED, payload: data });
export const AmbulanceDocumentUserAssignedSuccess = (data) => ({ type: AMBULANCE_DOCUMENT_USER_ASSIGNED_SUCCESS, payload: data });
export const AmbulanceDocumentUserAssignedError = (error) => ({ type: AMBULANCE_DOCUMENT_USER_ASSIGNED_ERROR, payload: error });

export const AmbulanceDocumentUsersForAssign = (data) => ({ type: AMBULANCE_DOCUMENT_USERS_FOR_ASSIGN, payload: data });
export const AmbulanceDocumentUsersForAssignSuccess = (data) => ({ type: AMBULANCE_DOCUMENT_USERS_FOR_ASSIGN_SUCCESS, payload: data });
export const AmbulanceDocumentUsersForAssignError = (error) => ({ type: AMBULANCE_DOCUMENT_USERS_FOR_ASSIGN_ERROR, payload: error });

export const AmbulanceDocumentList = (page, num_page, header, filters) => ({ type: AMBULANCE_DOCUMENT_LIST, payload: { page, num_page, header, filters } });
export const AmbulanceDocumentListSuccess = (data) => ({ type: AMBULANCE_DOCUMENT_LIST_SUCCESS, payload: data });
export const AmbulanceDocumentListError = (error) => ({ type: AMBULANCE_DOCUMENT_LIST_ERROR, payload: error });
export const AmbulanceDocumentListSearchChange = (data) => ({ type: AMBULANCE_DOCUMENT_LIST_SEARCH_CHANGE, payload: data });
export const AmbulanceDocumentListPageSet = (data) => ({ type: AMBULANCE_DOCUMENT_LIST_PAGE_SET, payload: data });

export const AmbulanceDocumentAssignModalSet = (data) => ({ type: AMBULANCE_DOCUMENT_ASSIGN_MODAL_SET, payload: data });
export const AmbulanceDocumentAssignChangeSet = (data) => ({ type: AMBULANCE_DOCUMENT_ASSIGN_CHANGE_SET, payload: data });
export const AmbulanceDocumentAssign = (page, num_page, header, filters, data) => ({ type: AMBULANCE_DOCUMENT_ASSIGN, payload: { page, num_page, header, filters, data } });
export const AmbulanceDocumentAssignSuccess = (data) => ({ type: AMBULANCE_DOCUMENT_ASSIGN_SUCCESS, payload: data });
export const AmbulanceDocumentAssignError = (error) => ({ type: AMBULANCE_DOCUMENT_ASSIGN_ERROR, payload: error });

export const AmbulanceDocumentValidateModalSet = (data) => ({ type: AMBULANCE_DOCUMENT_VALIDATE_MODAL_SET, payload: data });
export const AmbulanceDocumentValidateChangeSet = (data) => ({ type: AMBULANCE_DOCUMENT_VALIDATE_CHANGE_SET, payload: data });
export const AmbulanceDocumentValidate = (page, num_page, header, filters, data) => ({ type: AMBULANCE_DOCUMENT_VALIDATE, payload: { page, num_page, header, filters, data } });
export const AmbulanceDocumentValidateSuccess = (data) => ({ type: AMBULANCE_DOCUMENT_VALIDATE_SUCCESS, payload: data });
export const AmbulanceDocumentValidateError = (error) => ({ type: AMBULANCE_DOCUMENT_VALIDATE_ERROR, payload: error });

export const AmbulanceDocumentSeeModalSet = (data) => ({ type: AMBULANCE_DOCUMENT_SEE_MODAL_SET, payload: data });
export const AmbulanceDocumentSeeChangeSet = (data) => ({ type: AMBULANCE_DOCUMENT_SEE_CHANGE_SET, payload: data });
export const AmbulanceDocumentSeeDocument = (data) => ({ type: AMBULANCE_DOCUMENT_SEE_DOCUMENT, payload: data });
export const AmbulanceDocumentSeeDocumentSuccess = (data) => ({ type: AMBULANCE_DOCUMENT_SEE_DOCUMENT_SUCCESS, payload: data });
export const AmbulanceDocumentSeeDocumentError = (error) => ({ type: AMBULANCE_DOCUMENT_SEE_DOCUMENT_ERROR, payload: error });
